import React from 'react';
import withRouter from './withRouter.jsx';
import { Autocomplete, TextField } from '@mui/material';

const SearchBarHeader = () => {
  return(
    <div>
        <p>Find your preferred car</p>
    </div>
  );
};

const brands = ['Brand 1', 'Brand 2'];

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brand: brands[0],
      model: '',
      year_min: '1000',
      year_max: '3000',
      price_min: '0',
      price_max: '999999999',
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onClearFilter = this.onClearFilter.bind(this);
  }

  onChange(event, newValue) {
    const defaults = {
      brand: '',
      model: '',
      year_min: '1000',
      year_max: '3000',
      price_min: '0',
      price_max: '999999999',
    }
    const { name, value: textValue } = event.target;
    const value = newValue === undefined ? textValue : naturalValue;
    this.setState({
      [name] : value
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    const { brand } = this.state;
    const { model } = this.state;
    var { year_min, year_max } = this.state;
    var { price_min, price_max } = this.state;
    const { activateFilter } = this.props;
    if(year_min === '' || isNaN(year_min)) {
      year_min = '1000';
    }
    if(year_max === '' || isNaN(year_max)) {
      year_max = '3000';
    }
    if(price_min === '' || isNaN(price_min)) {
      price_min = '0';
    }
    if(price_max === '' || isNaN(price_max)) {
      price_max = '999999999';
    }
    year_min = parseInt(year_min);
    year_max = parseInt(year_max);
    price_min = parseInt(price_min);
    price_max = parseInt(price_max);
    activateFilter(brand, model, year_min, year_max, price_min, price_max);
  }

  async onClearFilter(e) {
    e.preventDefault();
    this.setState(
      { brand: '',
        model: '',
        year_min: '',
        year_max: '',
        price_min: '',
        price_max:'',
      }
    );
    const { activateFilter } = this.props;
    activateFilter('', 1000, 3000, 0, 999999999);
  }
    

  render() {
    const { brand } = this.state;
    const { model } = this.state;
    const { year_min, year_max } = this.state;
    const { price_min, price_max } = this.state;
    return (
      <div>
        <div>{`brand: ${brand !== null ? `'${brand}'` : 'null'}`}</div>
        <div>{`model: ${model !== null ? `'${model}'` : 'null'}`}</div>
        <Autocomplete
          value= {brand}
          onChange={(event, newBrand) => {
            this.setState({
              brand : newBrand
            });
          }}
          id="controllable-states-demo"
          options={brands}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Select Brand" />}
        />
        <TextField
          label="Model"
          value = {model}
          onChange={(event) => {
            this.setState({
              model: event.target.value
            });
          }}
        />
        <Autocomplete
          value= {brand}
          onChange={(event, newBrand) => {
            this.setState({
              brand : newBrand
            });
          }}
          id="controllable-states-demo"
          options={brands}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Select Brand" />}
        />
        <Autocomplete
          value= {brand}
          onChange={(event, newBrand) => {
            this.setState({
              brand : newBrand
            });
          }}
          id="controllable-states-demo"
          options={brands}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Select Brand" />}
        />
      </div>
    );
  }
}

export default withRouter(Search);
